import { Fragment, useState } from 'react';
import { Icon, IconSize, Typography } from '@shipengine/giger';
import { useTranslation } from '@packlink/translation-provider';
import { IconNames } from '@shipengine/giger-theme';
import { Tag } from '../nodes/TagNode';
import {
    getContentStyles,
    getIconColorStyles,
    getInfoStyles,
    getSummaryStyles,
    getTagsDescriptionStyles,
    getTagsHelpStyles,
    getTitleStyles,
} from './TagsHelpStyles';

export type TagsHelpProps = {
    tags: Tag[];
};

export function TagsHelp({ tags }: TagsHelpProps): JSX.Element {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const handleOnToggle = () => {
        setIsOpen((prev) => !prev);
    };

    return (
        <details onToggle={handleOnToggle} css={getTagsHelpStyles}>
            <summary css={getSummaryStyles}>
                <Typography variant="body1" component="span" css={getTitleStyles}>
                    <Icon name={IconNames.INFO} size={IconSize.SIZE_SMALL} css={[getIconColorStyles, getInfoStyles]} />
                    {t('text-editor.help.title')}
                </Typography>

                <Icon
                    name={isOpen ? IconNames.CHEVRON_TOP : IconNames.CHEVRON_BOTTOM}
                    size={IconSize.SIZE_REGULAR}
                    css={getIconColorStyles}
                />
            </summary>
            <div css={getContentStyles}>
                <Typography variant="body2" component="p">
                    {t('text-editor.help.description')}
                </Typography>

                <Typography variant="body2" component="p">
                    {t('text-editor.help.tags-list')}
                </Typography>

                <dl css={getTagsDescriptionStyles}>
                    {tags.map((tag) => (
                        <Fragment key={tag.key}>
                            <Typography variant="subtitle2" component="dt" css={getTitleStyles}>
                                {tag.translation}
                            </Typography>

                            <Typography variant="body2" component="dd">
                                {tag.description}
                            </Typography>
                        </Fragment>
                    ))}
                </dl>

                <Typography variant="body2" component="p">
                    {t('text-editor.help.footer')}
                </Typography>
            </div>
        </details>
    );
}
